import {
  PASSWORD_POLICY_START,
  PASSWORD_POLICY_DATA,
  PASSWORD_POLICY_UPSERT,
  PASSWORD_POLICY_DELETE,
  PASSWORD_POLICY_END,
} from "../../slices/type";

interface InitState {
  data: any;
  upsert: any;
  delete: any;
  loading: boolean;
  error: any;
}

const initState: InitState = {
  data: null,
  upsert: null,
  delete: null,
  loading: false,
  error: null,
};

interface Action {
  type: string;
  payload?: any;
  loading?: boolean;
}

const PasswordPolicy_Red = (state = initState, action: Action): InitState => {
  switch (action.type) {
    case PASSWORD_POLICY_START:
      return { ...state, loading: true };
    case PASSWORD_POLICY_DATA:
      return { ...state, data: action.payload, loading: false };
    case PASSWORD_POLICY_UPSERT:
      return { ...state, upsert: action.payload, loading: false };
    case PASSWORD_POLICY_DELETE:
      return { ...state, delete: action.payload, data: null, loading: false };
    case PASSWORD_POLICY_END:
      return { ...state, error: action.payload, loading: false };
    default:
      return state;
  }
};

export default PasswordPolicy_Red;
